import { render } from "./editCard.vue?vue&type=template&id=2c5c9846&scoped=true"
import script from "./editCard.vue?vue&type=script&lang=js"
export * from "./editCard.vue?vue&type=script&lang=js"

import "./editCard.vue?vue&type=style&index=0&id=2c5c9846&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5c9846"]])

export default __exports__